var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordionPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20605 0.000976562C8.64788 0.000976562 9.00586 0.358953 9.00586 0.800781V7.40723H15.6143C16.0561 7.40723 16.415 7.7652 16.415 8.20703C16.415 8.64886 16.0561 9.00684 15.6143 9.00684H9.00586V15.6152C9.00586 16.0571 8.64788 16.416 8.20605 16.416C7.76423 16.416 7.40625 16.0571 7.40625 15.6152V9.00684H0.799805C0.357977 9.00684 0 8.64886 0 8.20703C0 7.7652 0.357977 7.40723 0.799805 7.40723H7.40625V0.800781C7.40625 0.358953 7.76423 0.000976562 8.20605 0.000976562Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionPlus);
export default __webpack_public_path__ + "static/media/accordion-plus.e2bdd163f7d271eabb8a9e2028b5adaf.svg";
export { ForwardRef as ReactComponent };